import React from "react"
import GlobalHelper from "../../common/GlobalHelper"
import LocationSelect from "../../location/locationselect.component"
import Icon from "../../common/icon/icon.component"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

interface Props {
    locationId: string
    handleLocationSelection: (locationId: string) => void
}

const DashboardLocationContent: React.FC<Props> = ({ locationId, handleLocationSelection }) => {
    if (GlobalHelper.hasAccessToAllLocations()) {
        return (
            <div className={"dashboard-location-select"}>
                <LocationSelect
                    optionForAll={true}
                    value={locationId}
                    onChange={(locationIdSelected) => handleLocationSelection(locationIdSelected)}
                />
            </div>
        )
    } else {
        return (
            <div>
                <Icon className={"mr-1"} value={"map-marker-alt"} />
                {AppContext.getUserLoggedIn().attributes.location?.attributes.name ?? ""}
            </div>
        )
    }
}

export default DashboardLocationContent



// WEBPACK FOOTER //
// ./src/shortcuts/sections/DashboardLocationContent.tsx